if (!customElements.get("eck-footer-accordion")) {
  customElements.define(
    "eck-footer-accordion",
    class EckFooterAccordion extends HTMLElement {
      connectedCallback() {
        this._mq = window.matchMedia("(max-width: 749px)");
        this._onChange = () => this.sync();
        this._mq.addEventListener("change", this._onChange);
        this.sync();
      }

      disconnectedCallback() {
        if (this._mq) this._mq.removeEventListener("change", this._onChange);
      }

      // Mirror of the old IIFE's per-element rule: open on desktop, or when this
      // accordion is flagged always-open (the newsletter block carries
      // data-footer-accordion-open). On mobile, non-flagged accordions collapse.
      sync() {
        const details = this.querySelector("details");
        if (!details) return;
        details.open = !this._mq.matches || this.hasAttribute("data-footer-accordion-open");
      }
    },
  );
}
